
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import 'rxjs/Rx';

import { LoginService } from '../../login/shared/login.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class WorkRecListService {
    redirectUrl: string;

    constructor(
        private http: HttpClient,
        private _http: Http,
        private authenticate: LoginService
    ) { }

    getWorkRecListData(data: any) {
        data.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': data.token });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/worklist', data, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getSelectedStaffsDetails(data: any) {
        const headers = new HttpHeaders({ 
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/worklist/view?staff_id=['+data.staff_id+']&month='+data.month+'&sort='+data.sort+'&category='+data.category+'&branch='+data.branch+'&title='+data.title+'&csv='+data.csv+'&section='+data.section, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    exportCSVFunction(data: any): Observable<any> {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json'});
        // let options = {responseType: 'blob', headers: headers };
        return this.http.get(environment.SERVER_URL + '/worklist/view?staff_id=['+data.staff_id+']&month='+data.month+'&sort='+data.sort+'&category='+data.category+'&branch='+data.branch+'&title='+data.title+'&csv='+data.csv+'&section='+data.section, {responseType: 'blob', observe: 'response', headers: headers }).pipe(
                        map((res: HttpResponse<Blob>) => {
                            this.downloadFile(res, 'application/xlsx', 'WorkRecordList_' + data.month +`.xlsx`);
                        }),      
                        catchError(this.handleError),)
    }

    getAllDepartments() {
        const headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL +'/department/list', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getAllBranches() {
        const headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/branch_office', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getAllCategories() {
        const headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/employment_category', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getAllStatuses() {
        const headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        const options = { headers: headers };

        return this.http.get(environment.AUTH_SERVER_URL + '/employment_status/list', options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    // getAllSections() {
    //     const headers = new HttpHeaders({
    //         'Authorization': this.authenticate.getToken(),
    //         'Content-Type': 'application/json'
    //     });
    //     const options = { headers: headers };

    //     return this.http.get(environment.GMS +'/sections/all', options).pipe(
    //                 map(this.extractData),
    //                 catchError(this.handleError),);
    // }

    private extractData(res: Response | any) {
        return res.data || {};
    }
    downloadFile(blob: any, type: string, filename: string): string {
        const url = window.URL.createObjectURL(blob.body); // <-- work with blob directly

        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);

        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = filename;
        a.click();
        return url;
    }

    // private handleError (error: Response | any) {
    //     let errMsg: string;
    //     if (error instanceof Response) {
    //     const body = error.json() || '';
    //     const err = body.error || JSON.stringify(body);
    //     errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    //     } else {
    //     errMsg = error.message ? error.message : error.toString();
    //     }
    //     console.error(errMsg);
    //     return Observable.throw(errMsg);
    // }
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        // window.alert(errorMessage);
        return throwError(errorMessage);
    }
}
